import React, { useState } from 'react';
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip as ChartTooltip,
  Legend,
} from 'chart.js';
import { Pie } from 'react-chartjs-2';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import FAQSchema from '../../FAQSchema';
import AdBanner from '../AdPage/AdBanner';

// Register necessary components
ChartJS.register(
  ArcElement,
  ChartTooltip,
  Legend
);

const IciciCarloanEmiCalculator  = () => {
  const [loanAmount, setLoanAmount] = useState(500000);
  const [interestRate, setInterestRate] = useState(8);
  const [loanTenure, setLoanTenure] = useState(5);
  const [monthlyEMI, setMonthlyEMI] = useState(0);
  const [totalInterest, setTotalInterest] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);
  const [amortizationSchedule, setAmortizationSchedule] = useState([]);
  const [activeYear, setActiveYear] = useState(null);

  const calculateEMI = () => {
    const principal = loanAmount;
    const annualInterest = interestRate / 100;
    const monthlyInterest = annualInterest / 12;
    const tenureInMonths = loanTenure * 12;

    const emi =
      (principal * monthlyInterest * Math.pow(1 + monthlyInterest, tenureInMonths)) /
      (Math.pow(1 + monthlyInterest, tenureInMonths) - 1);

    const totalAmount = emi * tenureInMonths;
    const totalInterest = totalAmount - principal;

    setMonthlyEMI(emi.toFixed(2));
    setTotalInterest(totalInterest.toFixed(2));
    setTotalAmount(totalAmount.toFixed(2));

    const schedule = [];
    let balance = principal;
    // let currentYear = new Date().getFullYear();
    let currentYear = new Date().getFullYear();

    let currentMonth = 6;

    for (let i = 0; i < tenureInMonths; i++) {
      const interestForMonth = balance * monthlyInterest;
      const principalForMonth = emi - interestForMonth;
      balance -= principalForMonth;

      schedule.push({
        // month: i + 1,
        // year: year,
        month: (currentMonth + i) % 12 + 1, // Ensure month is in range 1-12
        year: currentYear + Math.floor((currentMonth + i) / 12),
        principalPaid: principalForMonth,
        interestPaid: interestForMonth,
        totalPayment: emi,
        balance: balance,
      });

      // if ((i + 1) % 12 === 0) {
      //   year++;
      // }
    }

    setAmortizationSchedule(schedule);
  };

  const handleLoanAmountChange = (e) => {
    const value = e.target.value;
    setLoanAmount(value === '' ? 0 : parseInt(value));
  };

  const handleInterestRateChange = (e) => {
    const value = e.target.value;
    setInterestRate(value === '' ? 0 : parseFloat(value));
  };

  const handleLoanTenureChange = (e) => {
    const value = e.target.value;
    setLoanTenure(value === '' ? 0 : parseInt(value));
  };

  const handleYearToggle = (year) => {
    setActiveYear(activeYear === year ? null : year);
  };

  const data = {
    labels: ['Principal Amount', 'Total Interest'],
    datasets: [
      {
        label: 'EMI Breakdown',
        data: [loanAmount, totalInterest],
        backgroundColor: ['#36A2EB', '#FF6384'],
      },
    ],
  };
function Icon({ id, open }) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={2}
            stroke="currentColor"
            className={`${id === open ? "rotate-180" : ""} h-5 w-5 transition-transform`}
        >
            <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
        </svg>
    );
  }
  
  
    const [activeIndex, setActiveIndex] = useState(0);
  
     
    const faqs = [
        {
            "question": "What is an EMI in a car loan context?",
            "answer": "EMI stands for Equated Monthly Installment. It’s a fixed monthly payment that includes principal and interest components over your loan term."
          },
          {
            "question": "Is the ICICI Car Loan EMI Calculator free to use?",
            "answer": "Yes. TheFinMaster’s ICICI Car Loan EMI Calculator is completely free and accessible to all users."
          },
          {
            "question": "Can I use the calculator for both new and used cars?",
            "answer": "Yes, the calculator works for both new and pre-owned car loans."
          },
          {
            "question": "How accurate is the EMI calculation?",
            "answer": "The calculator provides highly accurate estimates based on standard formulas, but your final EMI may vary based on ICICI Bank’s approval terms."
          },
          {
            "question": "Does ICICI Bank offer fixed or floating interest rates?",
            "answer": "ICICI typically offers fixed interest rates for car loans, ensuring EMI stability."
          },
          {
            "question": "What is the maximum car loan tenure with ICICI?",
            "answer": "The maximum tenure usually offered is 7 years (84 months)."
          },
          {
            "question": "Can I include processing fees in the EMI calculation?",
            "answer": "Processing fees are not included in the EMI but can be manually added for estimating the total cost."
          },
          {
            "question": "Does prepayment affect EMI?",
            "answer": "Yes. Making prepayments can reduce either your loan tenure or EMI amount depending on the repayment structure chosen."
          },
          {
            "question": "Can I change my tenure after taking the loan?",
            "answer": "Generally, tenure changes are not allowed after disbursal. It’s recommended to decide tenure before loan approval."
          },
          {
            "question": "Is CIBIL score important for EMI affordability?",
            "answer": "Absolutely. A higher credit score can help you secure better interest rates and reduce EMI burden."
          },
          {
            "question": "What documents are required for an ICICI car loan?",
            "answer": "You need identity proof, address proof, income documents, car quotation, and passport-sized photographs."
          },
          {
            "question": "What happens if I miss an EMI?",
            "answer": "Missing an EMI can result in penalty charges and negatively affect your credit score."
          },
          {
            "question": "Does TheFinMaster save my personal details?",
            "answer": "No. The EMI calculator is privacy-focused and does not store or request any personal information."
          },
          {
            "question": "Can I calculate EMIs for different interest rates simultaneously?",
            "answer": "You can manually input different interest rates to compare various EMI scenarios one at a time."
          },
          {
            "question": "Is there a mobile app for this calculator?",
            "answer": "Currently, it is a web-based tool, but it is fully optimized for smartphones and tablets."
          }
        ]
    const toggleAccordion = (index) => {
      if (activeIndex === index) {
          // If the clicked question is already expanded, collapse it
          setActiveIndex(null);
      } else {
          // If the clicked question is not expanded, expand it
          setActiveIndex(index);
      };
    }
  return (
    <>
     <Helmet>
          <title>ICICI Car Loan EMI Calculator – Get Instant EMI Estimates</title>
        <meta  name='description' content='Plan your car loan with the ICICI EMI Calculator. Discover monthly payments and total interest with ease and accuracy.'/>
        <link rel="canonical" href="https://thefinmaster.com/financial-tools-calculators/icici-car-loan-emi-calculator" />
        <meta name="robots" content="max-snippet:-1, max-image-preview:standard" />
        <meta name="robots" content="max-video-preview:-1" />
      </Helmet>

      <FAQSchema faqs={faqs} />
      {/* <nav className="text-gray-500 text-sm my-4 ml-10" aria-label="Breadcrumb">
      <ol className="list-none p-0 inline-flex">
        <li className="flex items-center">
          <Link to="/" className="text-blue-600 hover:text-blue-800 ">Home</Link>
          <svg className="w-4 h-4 mx-2 text-gray-500" fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L11.586 9 7.293 4.707a1 1 0 111.414-1.414l5 5a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0z" clipRule="evenodd" />
          </svg>
        </li>
        <li className="flex items-center">
          <Link to="/financial-tools-calculators" className="text-blue-600 hover:text-blue-800">Financial Tools Calculators</Link>
          <svg className="w-4 h-4 mx-2 text-gray-500" fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L11.586 9 7.293 4.707a1 1 0 111.414-1.414l5 5a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0z" clipRule="evenodd" />
          </svg>
        </li>
          <li className="flex items-center">
          <span className="text-gray-500 ">Icici Car Loan EMI Calculator</span>
        </li> 
      
      </ol>
    </nav> */}
        <div className="w-full flex justify-center items-center px-4 mt-20">
      <div className="w-full max-w-5xl h-auto object-contain rounded-lg shadow-md transition duration-300 hover:scale-105">
      <AdBanner displayOrder="1" />
      </div>
    </div>
        <div className='py-4'>
    <div className="container mx-auto p-4 shadow-xl rounded-md">
      <h1 className="text-2xl font-bold mb-4">ICICI Car Loan EMI Calculator</h1>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <div className="mb-4">
            <label className="block text-gray-700 font-semibold">Loan Amount</label>
            <div className="flex items-center">
              <input
                type="number"
                min="0"
                value={loanAmount}
                onChange={handleLoanAmountChange}
                className="w-1/2 p-2 border rounded mr-2"
              />
              <span className="text-gray-700">₹ {loanAmount.toLocaleString()}</span>
            </div>
            <input
              type="range"
              min="0"
              max="10000000"
              value={loanAmount}
              onChange={(e) => setLoanAmount(parseInt(e.target.value))}
              className="w-full mt-2"
            />
          </div>
          <div className="mb-4">
            <label className="block text-gray-700 font-semibold">Rate of Interest (P.A.)</label>
            <div className="flex items-center">
              <input
                type="number"
                min="0"
                max="100"
                step="0.1"
                value={interestRate}
                onChange={handleInterestRateChange}
                className="w-1/2 p-2 border rounded mr-2"
              />
              <span className="text-gray-700">{interestRate} %</span>
            </div>
            <input
              type="range"
              min="0"
              max="15"
              step="0.1"
              value={interestRate}
              onChange={(e) => setInterestRate(parseFloat(e.target.value))}
              className="w-full mt-2"
            />
          </div>
          <div className="mb-4">
            <label className="block text-gray-700 font-semibold">Loan Tenure (Years)</label>
            <div className="flex items-center">
              <input
                type="number"
                min="0"
                max="30"
                value={loanTenure}
                onChange={handleLoanTenureChange}
                className="w-1/2 p-2 border rounded mr-2"
              />
              <span className="text-gray-700">{loanTenure} Yr</span>
            </div>
            <input
              type="range"
              min="0"
              max="30"
              value={loanTenure}
              onChange={(e) => setLoanTenure(parseInt(e.target.value))}
              className="w-full mt-2"
            />
          </div>
          <button
            onClick={calculateEMI}
            className="bg-blue-500 text-white px-4 py-2 rounded"
          >
            Calculate
          </button>
        </div>
        <div>
          <div className="mb-4">
            <h2 className="text-xl font-bold">Results</h2>
            <p>Monthly EMI: ₹ {parseFloat(monthlyEMI).toLocaleString()}</p>
            <p>Total Principal Amount: ₹ {loanAmount.toLocaleString()}</p>
            <p>Total Interest: ₹ {parseFloat(totalInterest).toLocaleString()}</p>
            <p>Total Amount (Principal + Interest): ₹ {parseFloat(totalAmount).toLocaleString()}</p>
          </div>
          <div>
            <h2 className="text-xl font-bold">Breakdown</h2>
            <div className="flex justify-center">
              <Pie data={data} options={{ maintainAspectRatio: false }} width={300} height={300} />
            </div>
          </div>
        </div>
      </div>
      <div className="mt-6">
        <h2 className="text-xl font-bold mb-4">Amortization Schedule</h2>
        {amortizationSchedule.length > 0 && (
          <div className="flex flex-col space-y-4">
            {Array.from(new Set(amortizationSchedule.map(item => item.year))).map((year, idx) => (
              <div key={idx} className="mb-4 border rounded-md shadow-md">
                <div
                  className={`cursor-pointer text-lg font-semibold bg-gray-100 p-4 flex justify-between items-center ${activeYear === year ? 'bg-blue-100' : ''}`}
                  onClick={() => handleYearToggle(year)}
                >
                  <span>{year}</span>
                  <span>{activeYear === year ? '-' : '+'}</span>
                </div>
                {activeYear === year && (
                  <div className="overflow-x-auto">
                    <table className="min-w-full bg-white rounded-md shadow-md">
                      <thead>
                        <tr>
                          <th className="py-2 px-4 border-b">Month</th>
                          <th className="py-2 px-4 border-b">Principal Paid</th>
                          <th className="py-2 px-4 border-b">Interest Charged</th>
                          <th className="py-2 px-4 border-b">Total Payment</th>
                          <th className="py-2 px-4 border-b">Balance</th>
                        </tr>
                      </thead>
                      <tbody>
                        {amortizationSchedule.filter(item => item.year === year).map((item, idx) => (
                          <tr key={idx}>
                            <td className="py-2 px-4 border-b">{new Date(0, item.month - 1).toLocaleString('default', { month: 'short' })}</td>
                            <td className="py-2 px-4 border-b">₹ {item.principalPaid.toFixed(2).toLocaleString()}</td>
                            <td className="py-2 px-4 border-b">₹ {item.interestPaid.toFixed(2).toLocaleString()}</td>
                            <td className="py-2 px-4 border-b">₹ {item.totalPayment.toFixed(2).toLocaleString()}</td>
                            <td className="py-2 px-4 border-b">₹ {item.balance.toFixed(2).toLocaleString()}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
     <div className="flex flex-wrap lg:px-6 md:px-6 px-0 py-6" >
     <div className="w-full md:w-2/3 p-4 mx-auto">
     <div className="container mx-auto py-4">
          <h2 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
            Plan Your ICICI Car Loan Payments with TheFinMaster’s EMI Calculator
          </h2>
          <p className="text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg mt-2">
            Buying a car is a milestone that comes with financial planning and commitment. To ease your journey, TheFinMaster brings you a powerful and intuitive ICICI Car Loan EMI Calculator – a digital tool crafted to help you plan your ICICI car loan repayments efficiently. With just a few inputs, you can visualize your entire EMI schedule, make informed decisions, and prepare for financial responsibility without any surprises.
          </p>
          <p className="text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg mt-2">
            Whether you’re buying a compact car, an SUV, or a luxury sedan, the calculator will help you understand how much you need to pay every month, how much interest you’ll incur, and how you can manage your budget more effectively.
          </p>
</div>
          <div className="container mx-auto py-4">
            <h2 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              What is a Car Loan EMI?
            </h2>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              A Car Loan EMI (Equated Monthly Installment) is the fixed monthly amount you pay to your lender to repay the loan taken for purchasing a vehicle. This amount consists of two components – the principal amount (the original loan you borrowed) and the interest (the cost of borrowing from the bank).
            </p>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              The EMI remains constant throughout the loan tenure, although the ratio of principal and interest changes month to month. Initially, a higher portion of the EMI goes toward interest repayment, and gradually, more goes toward the principal. This repayment model is based on the concept of reducing balance method.
            </p>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              Understanding your EMI is essential before applying for a car loan, as it directly impacts your monthly budget, savings, and other financial commitments.
            </p>
          </div>

          <div className="container mx-auto py-4">
            <h2 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              What is ICICI Car Loan EMI Calculator?
            </h2>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              The ICICI Car Loan EMI Calculator by TheFinMaster is a smart financial tool that enables you to calculate your monthly car loan installments in seconds. It helps you simulate various loan scenarios by adjusting the loan amount, interest rate, and repayment tenure to find an EMI that fits your budget.
            </p>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              Instead of relying on manual calculations or guesswork, this tool gives you an accurate projection of your car loan repayment structure. Whether you're a first-time car buyer or looking to switch your car with a better model, this calculator ensures that you know what you're signing up for.
            </p>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              It is tailored specifically to mirror ICICI Bank’s car loan structure, helping you with realistic EMI figures, exact amortization breakdown, and clarity about total interest payable across your chosen loan tenure.
            </p>
          </div>

          <div className="container mx-auto py-4">
            <h2 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              Why Use TheFinMaster’s ICICI Car Loan EMI Calculator?
            </h2>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              Using TheFinMaster’s ICICI EMI calculator offers several tangible benefits beyond just convenience:
            </p>
            <ul className="list-disc pl-6 mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <li><strong>Instant and Accurate Calculations:</strong> Eliminate human error and get precise EMI figures instantly with a single click.</li>
              <li><strong>Zero Learning Curve:</strong> With a user-friendly interface, even first-time users can navigate and calculate with ease.</li>
              <li><strong>Tailored to ICICI Loan Policies:</strong> The calculator is optimized to align with ICICI Bank’s car loan offerings, including typical interest rates and tenure options.</li>
              <li><strong>Multi-Scenario Analysis:</strong> Run unlimited variations in loan amounts and interest rates to test different what-if situations.</li>
              <li><strong>Saves Time and Mental Effort:</strong> No more struggling with spreadsheets or financial formulas.</li>
              <li><strong>Financial Preparedness:</strong> Helps you plan your EMIs and compare loan structures before applying, ensuring you’re never caught off-guard.</li>
              <li><strong>Mobile-Friendly Interface:</strong> Access and use it seamlessly from your mobile device, anywhere, anytime.</li>
            </ul>
          </div>

          <div className="container mx-auto py-4">
            <h2 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              How Does the ICICI Car Loan EMI Calculator Work?
            </h2>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              The calculator is driven by the standard EMI formula:
            </p>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              EMI = [P x R x (1+R)^N] / [(1+R)^N – 1]
            </p>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              Where:
            </p>
            <ul className="list-disc pl-6 mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <li>P = Principal loan amount</li>
              <li>R = Monthly interest rate (annual rate divided by 12 × 100)</li>
              <li>N = Loan tenure in months</li>
            </ul>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <strong>Steps to Use:</strong>
            </p>
            <ul className="list-disc pl-6 mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <li><strong>Input the Loan Amount:</strong> Enter the amount you plan to borrow from ICICI Bank.</li>
              <li><strong>Enter the Interest Rate:</strong> Input ICICI’s interest rate (typically ranges from 8% to 10% depending on profile).</li>
              <li><strong>Set the Tenure:</strong> Choose your repayment period – usually between 12 to 84 months.</li>
              <li><strong>Click Calculate:</strong> Instantly view your monthly EMI, total interest payable, and total amount to be repaid.</li>
            </ul>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              This helps you align the EMI with your income and expense patterns, ensuring a balanced financial decision.
            </p>
          </div>
          <div className="w-full flex justify-center items-center my-6 px-4">
          <div className="w-full max-w-[984px]">

     
        <AdBanner displayOrder="3" />
        </div>
         
        </div>
          <div className="container mx-auto py-4">
            <h2 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              What is the Amortisation Schedule?
            </h2>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              The amortization schedule is a complete table of loan repayment broken down into periodic installments. It shows how much of your EMI goes toward interest and how much goes toward principal in each month of the loan tenure.
            </p>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              Over time, the interest component reduces, and the principal component increases, even though the EMI amount remains constant.
            </p>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <strong>Sample 12-Month Amortization Schedule for ₹6,00,000 at 9% Interest (5-Year Loan Tenure):</strong>
            </p>
            {/* <div className="overflow-x-auto">
              <table className="w-full text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg mt-4 border-collapse">
                <thead>
                  <tr className="bg-gray-100">
                    <th className="border px-4 py-2 text-left">Month</th>
                    <th className="border px-4 py-2 text-left">Opening Balance</th>
                    <th className="border px-4 py-2 text-left">EMI (₹)</th>
                    <th className="border px-4 py-2 text-left">Interest (₹)</th>
                    <th className="border px-4 py-2 text-left">Principal (₹)</th>
                    <th className="border px-4 py-2 text-left">Closing Balance</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="border px-4 py-2">1</td>
                    <td className="border px-4 py-2">₹6,00,000</td>
                    <td className="border px-4 py-2">₹12,455</td>
                    <td className="border px-4 py-2">₹4,500</td>
                    <td className="border px-4 py-2">₹7,955</td>
                    <td className="border px-4 py-2">₹5,92,045</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">2</td>
                    <td className="border px-4 py-2">₹5,92,045</td>
                    <td className="border px-4 py-2">₹12,455</td>
                    <td className="border px-4 py-2">₹4,440</td>
                    <td className="border px-4 py-2">₹8,015</td>
                    <td className="border px-4 py-2">₹5,84,030</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">3</td>
                    <td className="border px-4 py-2">₹5,84,030</td>
                    <td className="border px-4 py-2">₹12,455</td>
                    <td className="border px-4 py-2">₹4,380</td>
                    <td className="border px-4 py-2">₹8,075</td>
                    <td className="border px-4 py-2">₹5,75,955</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">4</td>
                    <td className="border px-4 py-2">₹5,75,955</td>
                    <td className="border px-4 py-2">₹12,455</td>
                    <td className="border px-4 py-2">₹4,320</td>
                    <td className="border px-4 py-2">₹8,135</td>
                    <td className="border px-4 py-2">₹5,67,820</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">5</td>
                    <td className="border px-4 py-2">₹5,67,820</td>
                    <td className="border px-4 py-2">₹12,455</td>
                    <td className="border px-4 py-2">₹4,260</td>
                    <td className="border px-4 py-2">₹8,195</td>
                    <td className="border px-4 py-2">₹5,59,625</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">6</td>
                    <td className="border px-4 py-2">₹5,59,625</td>
                    <td className="border px-4 py-2">₹12,455</td>
                    <td className="border px-4 py-2">₹4,197</td>
                    <td className="border px-4 py-2">₹8,258</td>
                    <td className="border px-4 py-2">₹5,51,367</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">7</td>
                    <td className="border px-4 py-2">₹5,51,367</td>
                    <td className="border px-4 py-2">₹12,455</td>
                    <td className="border px-4 py-2">₹4,135</td>
                    <td className="border px-4 py-2">₹8,320</td>
                    <td className="border px-4 py-2">₹5,43,047</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">8</td>
                    <td className="border px-4 py-2">₹5,43,047</td>
                    <td className="border px-4 py-2">₹12,455</td>
                    <td className="border px-4 py-2">₹4,071</td>
                    <td className="border px-4 py-2">₹8,384</td>
                    <td className="border px-4 py-2">₹5,34,663</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">9</td>
                    <td className="border px-4 py-2">₹5,34,663</td>
                    <td className="border px-4 py-2">₹12,455</td>
                    <td className="border px-4 py-2">₹4,007</td>
                    <td className="border px-4 py-2">₹8,448</td>
                    <td className="border px-4 py-2">₹5,26,215</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">10</td>
                    <td className="border px-4 py-2">₹5,26,215</td>
                    <td className="border px-4 py-2">₹12,455</td>
                    <td className="border px-4 py-2">₹3,942</td>
                    <td className="border px-4 py-2">₹8,513</td>
                    <td className="border px-4 py-2">₹5,17,702</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">11</td>
                    <td className="border px-4 py-2">₹5,17,702</td>
                    <td className="border px-4 py-2">₹12,455</td>
                    <td className="border px-4 py-2">₹3,883</td>
                    <td className="border px-4 py-2">₹8,572</td>
                    <td className="border px-4 py-2">₹5,09,130</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">12</td>
                    <td className="border px-4 py-2">₹5,09,130</td>
                    <td className="border px-4 py-2">₹12,455</td>
                    <td className="border px-4 py-2">₹3,818</td>
                    <td className="border px-4 py-2">₹8,637</td>
                    <td className="border px-4 py-2">₹5,00,493</td>
                  </tr>
                </tbody>
              </table>
            </div> */}
            <div className="mt-6">
  {/* Table view for medium and up */}
  <div className="hidden md:block overflow-x-auto">
    <table className="w-full text-lg text-gray-600 mt-4 border-collapse">
      <thead>
        <tr className="bg-gray-100">
          <th className="border px-4 py-2 text-left">Month</th>
          <th className="border px-4 py-2 text-left">Opening Balance(₹)</th>
          <th className="border px-4 py-2 text-left">EMI (₹)</th>
          <th className="border px-4 py-2 text-left">Interest (₹)</th>
          <th className="border px-4 py-2 text-left">Principal(₹)</th>
          <th className="border px-4 py-2 text-left">Closing Balance(₹)</th>

        </tr>
      </thead>
      <tbody>
        {[
          
       
          ["1", "₹6,00,000", "₹12,455", "₹4,500", "₹7,955", "₹5,92,045"],
          ["2", "₹5,92,045", "₹12,455", "₹4,440", "₹8,015", "₹5,84,030"],
          ["3", "₹5,84,030", "₹12,455", "₹4,380", "₹8,075", "₹5,75,955"],
          ["4", "₹5,75,955", "₹12,455", "₹4,320", "₹8,135", "₹5,67,820"],
          ["5", "₹5,67,820", "₹12,455", "₹4,260", "₹8,195", "₹5,59,625"],
          ["6", "₹5,59,625", "₹12,455", "₹4,197", "₹8,258", "₹5,51,367"],
          ["7", "₹5,51,367", "₹12,455", "₹4,135", "₹8,320", "₹5,43,047"],
          ["8", "₹5,43,047", "₹12,455", "₹4,071", "₹8,384", "₹5,34,663"],
          ["9", "₹5,34,663", "₹12,455", "₹4,007", "₹8,448", "₹5,26,215"],
          ["10", "₹5,26,215", "₹12,455", "₹3,942", "₹8,513", "₹5,17,702"],
          ["11", "₹5,17,702", "₹12,455", "₹3,883", "₹8,572", "₹5,09,130"],
          ["12", "₹5,09,130", "₹12,455", "₹3,818", "₹8,637", "₹5,00,493"]
     
        ].map(([month, emi, interest, principal, balance, closing], index) => (
          <tr key={index}>
            <td className="border px-4 py-2">{month}</td>
            <td className="border px-4 py-2">{emi}</td>
            <td className="border px-4 py-2">{interest}</td>
            <td className="border px-4 py-2">{principal}</td>
            <td className="border px-4 py-2">{balance}</td>
             <td className="border px-4 py-2">{closing}</td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>

  {/* Card layout for small screens */}
  <div className="md:hidden space-y-4 mt-4">
    {[
         ["1", "₹6,00,000", "₹12,455", "₹4,500", "₹7,955", "₹5,92,045"],
         ["2", "₹5,92,045", "₹12,455", "₹4,440", "₹8,015", "₹5,84,030"],
         ["3", "₹5,84,030", "₹12,455", "₹4,380", "₹8,075", "₹5,75,955"],
         ["4", "₹5,75,955", "₹12,455", "₹4,320", "₹8,135", "₹5,67,820"],
         ["5", "₹5,67,820", "₹12,455", "₹4,260", "₹8,195", "₹5,59,625"],
         ["6", "₹5,59,625", "₹12,455", "₹4,197", "₹8,258", "₹5,51,367"],
         ["7", "₹5,51,367", "₹12,455", "₹4,135", "₹8,320", "₹5,43,047"],
         ["8", "₹5,43,047", "₹12,455", "₹4,071", "₹8,384", "₹5,34,663"],
         ["9", "₹5,34,663", "₹12,455", "₹4,007", "₹8,448", "₹5,26,215"],
         ["10", "₹5,26,215", "₹12,455", "₹3,942", "₹8,513", "₹5,17,702"],
         ["11", "₹5,17,702", "₹12,455", "₹3,883", "₹8,572", "₹5,09,130"],
         ["12", "₹5,09,130", "₹12,455", "₹3,818", "₹8,637", "₹5,00,493"]
    ].map(([month, emi, interest, principal, balance, closing], index) => (
      <div key={index} className="bg-white shadow rounded-xl p-4 text-sm text-gray-700 space-y-1 border">
        <div><span className="font-semibold">Month:</span> {month}</div>
        <div><span className="font-semibold">Opening Balance  (₹):</span> {emi}</div>
        <div><span className="font-semibold">EMI   (₹):</span> {interest}</div>
        <div><span className="font-semibold">Interest  (₹):</span> {principal}</div>
        <div><span className="font-semibold"> Principal(₹):</span> {balance}</div>
        <div><span className="font-semibold"> Closing Balance(₹):</span> {closing}</div>

      </div>
    ))}
  </div>
</div>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              This schedule gives you a complete view of how your debt reduces over time and lets you pre-plan early repayments if you wish to.
            </p>
          </div>

          <div className="container mx-auto py-4">
            <h2 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              Factors Affecting Your Car Loan EMI
            </h2>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              Several variables influence how much EMI you pay every month. Understanding these factors gives you control over structuring a financially sound loan.
            </p>
            <ul className="list-disc pl-6 mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <li><strong>✅ 1. Loan Amount</strong><br />
                Higher principal = higher EMI. If you’re trying to reduce your EMI, consider making a higher down payment.
              </li>
              <li><strong>✅ 2. Interest Rate</strong><br />
                SBI offers car loan interest rates typically ranging from 8.75% to 9.50% depending on your credit score and the loan scheme. Even a 0.25% change can affect your total interest substantially.
              </li>
              <li><strong>✅ 3. Tenure</strong><br />
                Shorter tenures increase EMI but reduce interest costs. Longer tenures do the opposite. Always balance monthly affordability with long-term cost.
              </li>
              <li><strong>✅ 4. Credit Score</strong><br />
                A credit score of 750+ can help you qualify for lower interest rates. A low score might result in higher EMIs.
              </li>
              <li><strong>✅ 5. Vehicle Type</strong><br />
                Loans for new cars typically come with better terms compared to used cars. SBI also offers concessional rates on electric vehicles.
              </li>
              <li><strong>✅ 6. Income Stability</strong><br />
                Banks assess your monthly income and liabilities to decide your EMI-to-income ratio. Your loan eligibility and EMI depend on this ratio.
              </li>
            </ul>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              Understanding these factors helps you take control of your loan terms.
            </p>
          </div>
        </div>

     <div className="w-full md:w-1/3 p-4">
       <div className="bg-white shadow-md rounded-lg overflow-hidden">
         <div className="bg-blue-100 px-4 py-2 border-b border-blue-600 ">
           <h2 className="text-lg font-semibold ">Popular Categories</h2>
         </div>
         <div className="p-2 ">
         <ul>
                                <Link to='/financial-tools-calculators/swp-calculator'>
                                    <li className="py-2  hover:bg-slate-100 border-b border-gray-300">SWP Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/mutul-fund-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Mutual Fund Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/sukanya-samriddhi-yojana-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Samriddhi Yojana Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/fd-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">FD Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/rd-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">RD Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/nps-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">NPS Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/hra-exemption-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">HRA Exemption Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/retirement-planning-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Retirement Planning Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/emi-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">EMI Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/simple-interest-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Simple Interest Calculator</li>

                                </Link><Link to='/financial-tools-calculators/compound-interest-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Compound Interest Calculator</li>

                                </Link><Link to='/financial-tools-calculators/nsc-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">NSC Calculator</li>

                                </Link><Link to='/financial-tools-calculators/step-up-sip-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Step Up Sip Calculator</li>

                                </Link><Link to='/financial-tools-calculators/income-tax-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Income Tax Calculator</li>
                                    
                                </Link><Link to='/financial-tools-calculators/home-loan-emi-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Home Loan Emi Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/car-loan-emi-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Car Loan Emi Calculator</li>
                                </Link>
                                {/* {categories.map(category => (
       <Link key={category.id} to={`/category/${category.id}`}>
         <li className="py-2 border-b border-gray-300">{category.name}</li>
       </Link>
     ))} */}
                            </ul>
                        </div>
                    </div>

                            {/* Ad Banner */}
                      <div className="mt-4">
                        <div className="bg-white shadow-md rounded-lg overflow-hidden">
                          <div className="p-3 w-full h-auto rounded-md object-cover">
                            <AdBanner displayOrder="2" />
                          </div>
                        </div>
                      </div>
                    <div className="bg-white shadow-md rounded-lg overflow-hidden mt-4">
                        <div className="bg-blue-100 px-4 py-2 border-b border-blue-600">
                            <h2 className="text-lg font-semibold">More Categories</h2>
                        </div>
                        <div className="p-2">
                        <ul>
                                <Link to='/financial-tools-calculators/gratuity-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Gratuity Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/APY-calculator'>
                                    <li className="py-2 border- hover:bg-slate-100 border-gray-300">APY Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/cagr-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">CAGR Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/gst-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">GST Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/flat-vs-reducing-rate-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Flat Vs Reducing Rate Calculator</li>
                                </Link>
                                {/* <Link to='/financial-tools-calculators/equity-margin-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Equity Margin Calculator</li>
                                </Link> */}
                                <Link to='/financial-tools-calculators/inflation-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Inflation Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/salary-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Salary Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/brokerage-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Brokerage Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/tds-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">TDS Calculator</li>
                                </Link>
             {/* {moreCategories.map(category => (
       <Link key={category.id} to={`/category/${category.id}`}>
         <li className="py-2 border-b border-gray-300">{category.name}</li>
       </Link>
     ))} */}
           </ul>
         </div>
       </div>

     </div>

   </div>
   </div>
   <div className="max-w-4xl mx-auto lg:px-6 md:px-6 px-2 py-6">
                <h2 className="text-center text-2xl md:text-2xl lg:text-3xl font-bold mb-8">Frequently Asked Questions</h2>
                <div className="space-y-4">
                    {faqs.map((faq, index) => (
                        <div key={index} className="border rounded-lg overflow-hidden shadow-md">
                            <button
                                onClick={() => toggleAccordion(index)}
                                className="w-full p-4 text-left text-lg font-semibold focus:outline-none flex justify-between items-center"
                            >
                                {faq.question}
                                <Icon id={index} open={activeIndex} />
                            </button>
                            {activeIndex === index && (
                                <div className="p-4 bg-gray-100">
                                    <p className="text-gray-700">{faq.answer}</p>
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            </div>
   </>
  );
};

export default IciciCarloanEmiCalculator ;
